import instance from '@/services/repository';
import { AxiosResponse } from 'axios';

const resource = '/contacts';

export default {
    get(companyId?: string) {
        return companyId ? instance.get(`${resource}?companyId=${companyId}`) : instance.get(`${resource}`);
    },
    lookup(searchOptions: any, relationId?: string, type?: string, tunnelGroupsId?: string) {
        let url = `${resource}/Lookup`;
        if (relationId || type) {
            url += '?';
            if (relationId) {
                url += `relationId=${relationId}`;
                if (type) {
                    url += `&type=${type}`;
                }
            } else {
                url += `type=${type}`;
            }

            if (tunnelGroupsId) {
                url += `&tunnelGroupsId=${tunnelGroupsId}`;
            }
        }
        return instance.post(url, searchOptions);
    },
    getSingle(id: string) {
        return instance.get(`${resource}/${id}`);
    },
    create(payload: any, relationId?: string) {
        if (relationId && relationId !== '') {
            return instance.post(`${resource}/${payload.type}?relationId=${relationId}`, payload);
        } else {
            return instance.post(`${resource}/${payload.type}`, payload);
        }
    },
    update(payload: any) {
        payload.defaultPrice = null;
        return instance.put(`${resource}/${payload.type}/${payload.id}`, payload);
    },
    checkVatNumber(vatNumber: string) {
        return instance.post(`${resource}/Company/CheckVatNumber/${vatNumber}`, null);
    },
    delete(payload: any) {
        return instance.delete(`${resource}/${payload.id}`);
    },
    getRelations(contactId: string) {
        return instance.get(`${resource}/${contactId}/Relations`);
    },
    postRelation(relation: IContactRelation) {
        return instance.post(`${resource}/${relation.contactA}/Relations`, relation);
    },
    RemoveRelation(contactA: string, contactB: string) {
        return instance.delete(`${resource}/${contactA}/Relations/${contactB}`);
    },
    getPricingAgreements(contactId: string, quotationId?: string) {
        if (quotationId) {
            return instance.get<IPricingAgreementDtu[]>(`${resource}/${contactId}/PricingAgreements?quotation=${quotationId}`);
        } else {
            return instance.get<IPricingAgreementDtu[]>(`${resource}/${contactId}/PricingAgreements`);
        }
    },
    postPricingAgreement(contactId: string, agreement: IPricingAgreement) {
        return instance.post(`${resource}/${contactId}/PricingAgreements`, agreement);
    },
    RemovePricingAgreement(contactId: string, agreement: IPricingAgreement) {
        return instance.post(`${resource}/${contactId}/PricingAgreements/Remove`, agreement);
    },
    getLabourAgreements(contactId: string) {
        return instance.get<ISubcontractorLabourAgreementDtu[]>(`${resource}/${contactId}/LabourAgreements`);
    },
    getLabourAgreementsPrice(contactId: string, articleId: string, projectId: string) {
        return instance.get<number>(`${resource}/${contactId}/LabourAgreements/${articleId}?projectId=${projectId}`);
    },
    postLabourAgreement(contactId: string, agreement: ISubcontractorLabourAgreement) {
        return instance.post(`${resource}/${contactId}/LabourAgreements`, agreement);
    },
    RemoveLabourAgreement(contactId: string, agreement: ISubcontractorLabourAgreement) {
        return instance.post(`${resource}/${contactId}/LabourAgreements/Remove`, agreement);
    },
};
